module.exports = "<ul> <li> 1 </li> <li> 2 </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subnav.vue
// module id = 54
// module chunks = 0